import { defineComponent as n, createBlock as r, openBlock as l, unref as p, mergeProps as a, withCtx as c, createElementVNode as d } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconBlocked",
  __name: "IconBlocked",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (m, e) => (l(), r(p(i), a(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        d("path", {
          "fill-rule": "evenodd",
          d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18M7.254 17.806A7.5 7.5 0 0 0 17.806 7.254L7.254 17.806M12 4.5a7.5 7.5 0 0 0-5.807 12.245L16.745 6.193A7.467 7.467 0 0 0 12 4.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
